import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CustomerEnum } from '../enums/customer.enum';
import { ENVIRONMENT_TOKEN, EnvironmentToken } from '../models/environment-injection.interface';

@Directive({
  selector: '[appCustomerNot]'
})
export class CustomerNotDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    @Inject(ENVIRONMENT_TOKEN) private environment: EnvironmentToken
  ) {}

  @Input() set appCustomerNot(customers: CustomerEnum[]) {
    const customerFromConfig = this.environment.customer;
    const isCustomerAllowedToView = customers.every((cutomer: CustomerEnum) => cutomer !== customerFromConfig);
    if (isCustomerAllowedToView && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isCustomerAllowedToView && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
